<!-- 标题模板 -->
<template>
  <div class="title_wrap">{{ title }}</div>
</template>

<script>
export default {
  name: 'TitleComponent',
  props: {
    title: {
      type: String,
      default: '这是标题内容',
    },
  },
  data() {
    return {}
  },

  components: {},

  methods: {},

  mounted() { },
}
</script>
<style lang="less" scoped>
.title_wrap {
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 1px;
  padding: 20px 15px;
  &::before {
    position: relative;
    top: 3px;
    display: inline-block;
    width: 4px;
    height: 18px;
    background-color: var(--btnBgColor);
    margin-right: 5px;
    border-radius: 2px;
    content: "";
  }
}
</style>
